import { EXPRESSIONS_COLORS } from '../constant';

const makeMovingAverage = (data, window) => {
    if (!data || !window || window <= 0 || data.length < window) {
        return [];
    }
    let index = window - 1;
    const length = data.length + 1;
    const simpleMovingAverages = [];
    while (++index < length) {
        const windowSlice = data.slice(index - window, index);
        const obj = {
            dateTime: windowSlice[windowSlice.length - 1].dateTime,
        };
        for (const [expression] of Object.entries(EXPRESSIONS_COLORS)) {
            const sum = windowSlice.reduce((prev, curr) => prev + curr[expression], 0);
            obj[expression] = (sum / window).toFixed(2);
        }
        simpleMovingAverages.push(obj);
    }

    return simpleMovingAverages;
};

export default makeMovingAverage;
